module.exports = __webpack_public_path__ + "static/media/Ferroseed_gaussian2.a326a52f.png";